import { ReactElement } from 'react';
import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export interface IStatItemProps {
  title: string;
  value: string | ReactElement;
}

export function StatItem({ title, value }: IStatItemProps): ReactElement {
  const { classes } = useStyles();

  return (
    <div key={title} className={classes.root}>
      <div className={classes.title}>{title}</div>

      <div className={classes.value}>{value}</div>
    </div>
  );
}

const useStyles = makeStyles()(theme => ({
  root: {
    textAlign: 'center',
    width: '25%',
    minWidth: 170,

    [theme.breakpoints.up('sm')]: {
      '&:not(:last-of-type)': {
        borderRight: `1px solid ${theme.palette.background.default}`,
      },
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2.5),
      position: 'relative',
      borderRadius: 12,
      background: `linear-gradient(110.01deg, ${theme.palette.background.default} 8.7%, ${theme.palette.primary.contrastText} 40.24%)`,

      '&:before': {
        display: 'block',
        content: '""',
        position: 'absolute',
        inset: '0',
        borderRadius: 12,
        padding: theme.spacing(0.5),
        background: `linear-gradient(170deg, ${theme.palette.secondary.light} 3.74%, ${theme.palette.primary.main} 7.03%, ${theme.palette.secondary.main} 12.22%, ${theme.palette.secondary.dark} 25.76%, ${theme.palette.background.default} 41.68%)`,
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
      },
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.2,
    color: alpha(theme.palette.secondary.contrastText, 0.5),

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(12),
    },
  },
  value: {
    fontSize: theme.typography.pxToRem(20),
    lineHeight: 1.2,
    color: theme.palette.secondary.contrastText,
    marginTop: theme.spacing(1),
    fontWeight: 600,
  },
}));
